import { defineComponent } from "vue";
import { V as VListItem } from "./_VListItem-508e4b13.mjs";
import { d as doContactItemComponentSetup } from "./_common-fcf3ef61.mjs";
import { M as MalarkeyContactAvatar } from "./MalarkeyContactAvatar-1b079ba3.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyContactSearchItem",
  components: {
    MalarkeyContactAvatar
  },
  props: {
    ...VListItem.props,
    /**
     * The roster item to render
     */
    user: {
      type: Object,
      default: void 0
    },
    /**
     * Determines if a checkbox should be displayed
     */
    selectable: {
      type: Boolean,
      default: false
    }
  },
  emits: [...Object.keys({ ...VListItem.emits })],
  setup(props) {
    return doContactItemComponentSetup(props, "MalarkeyContactSearchItem");
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs.map
